<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
<div class="big-container">
  <h1>Score Summary</h1>
  <mat-table [dataSource]="levels">

    <!-- User Score -->
    <ng-container matColumnDef="score">
      <mat-header-cell *matHeaderCellDef class="title-font"> Scores </mat-header-cell>
      <mat-cell *matCellDef="let row" [ngClass]="row.color">
        <div>
          @for (submission of currentSubmissions(); track submission.id) {
            <div>{{ showScore(row, submission) }}</div>
          }
        </div>
      </mat-cell>
    </ng-container>

    <!-- Score Range -->
    <ng-container matColumnDef="scoremin">
      <mat-header-cell *matHeaderCellDef class="title-font"> Range </mat-header-cell>
      <mat-cell *matCellDef="let row" [ngClass]="row.color">
        {{row.scoremin}}-{{row.scoremax}}
      </mat-cell>
    </ng-container>

    <!-- Name Definition -->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef class="title-font"> Level </mat-header-cell>
      <mat-cell *matCellDef="let row" [ngClass]="row.color">
        <div>
          <div>Level {{ row.level }}</div>
          <div>{{ row.name }}</div>
          <div>({{ row.color }})</div>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Header and Row Declarations -->
    <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsToDisplay" title="{{ row.definition }}"></mat-row>
  </mat-table>
</div>
@if (!activeSubmission) {
  <div>No Active Submission</div>
}
